import React, { useEffect, useRef, useState } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";

const PRESETS = ["#9D4EDD", "#D4AF37", "#89CFF0", "#E57373", "#90EE90", "#F59E0B", "#EC4899", "#FFFFFF"];

export const ColorPopover = ({ value = "#D4AF37", onChange, testid = "color" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    if (open) document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="relative shrink-0" ref={ref}>
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testid}-swatch`}
        className={`w-9 h-9 rounded-lg border-2 cursor-pointer ${open ? "border-[#D4AF37]" : "border-white/15"}`}
        style={{ background: /^#[0-9a-fA-F]{6}$/.test(value) ? value : "#89CFF0" }} title="Pick a colour" />
      {open && (
        <div data-testid={`${testid}-panel`} className="absolute z-50 left-0 mt-2 w-72 rounded-2xl border border-white/12 bg-[#140F1E] p-4 shadow-2xl" onClick={(e) => e.stopPropagation()}>
          <p className="text-xs text-[#A19DB0] mb-2">Colour code</p>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-11 h-11 rounded-lg border-2 border-[#D4AF37]/60 shrink-0" style={{ background: /^#[0-9a-fA-F]{6}$/.test(value) ? value : "#89CFF0" }} />
            <div className="flex-1 flex items-center rounded-xl bg-white/5 border border-white/10 px-3 py-2">
              <span className="text-[#A19DB0] font-mono text-sm">#</span>
              <HexColorInput color={value} onChange={onChange} data-testid={`${testid}-hex`} className="w-full bg-transparent outline-none text-sm font-mono uppercase tracking-wide ml-0.5" />
            </div>
          </div>
          <div className="flex gap-2 mb-3 flex-wrap">
            {PRESETS.map((p) => (
              <button key={p} type="button" onClick={() => onChange(p)} data-testid={`${testid}-preset-${p.replace("#", "")}`}
                className="w-8 h-8 rounded-full border-2 transition-transform active:scale-90" style={{ background: p, borderColor: (value || "").toLowerCase() === p.toLowerCase() ? "#fff" : "transparent" }} />
            ))}
          </div>
          <div className="cp-wrap"><HexColorPicker color={/^#[0-9a-fA-F]{6}$/.test(value) ? value : "#89CFF0"} onChange={onChange} /></div>
        </div>
      )}
    </div>
  );
};

export default ColorPopover;
